import Helper from '@lovata/popup-helper';

export default new class feedbackPopup {
  constructor() {
    this.drawerBtnSelector = 'js-feedback-popup';
    this.panelSelector = 'feedback-popup-panel';
    this.panelOpenSelector = 'feedback-popup_hidden';
    this.drawerCloseSelector = 'feedback-popup-panel__close';

    this.classFormSelector = 'feedback-popup__form';
    this.submitBtnSelector = 'feedback-popup__submit';

    this.formNameInput = 'form__name';
    this.formEmailInput = 'form__email';
    this.formPhoneInput = 'form__phone';
    this.formQuestionInput = 'form__question';
    this.inValidSelector = '_invalid';
    this.preLoaderSelector = 'feedback-popup__preloader';

    this.openForm();
    this.initForm();
  }

  openForm() {
    $(document).on('click', `.${this.drawerBtnSelector}`, () => {
      const panel = $(`.${this.panelSelector}`);
      const isOpen = panel.hasClass(this.panelOpenSelector);
      const closeBtnNode = document.querySelector(`.${this.drawerCloseSelector}`);

      Helper.setBodyScrollState(!isOpen);
      Helper.overlayController(isOpen);

      panel.toggleClass(this.panelOpenSelector);
      Helper.overlayHandler(isOpen, closeBtnNode, panel[0]);
    });
  }

  initForm() {
    const form = document.querySelector(`.${this.classFormSelector}`);

    if (!form) return;

    const submitBtn = form.querySelector(`.${this.submitBtnSelector}`);

    submitBtn.addEventListener('click', () => {
      setTimeout(() => {
        this.checkForm(form);
      }, 0);
    });
  }

  checkForm(form) {
    if (form.matches(`.${this.inValidSelector}`)) return;

    const formName = form.querySelector(`.${this.formNameInput}`);
    const name = formName.value;

    const formEmail = form.querySelector(`.${this.formEmailInput}`);
    const email = formEmail.value;

    const formPhone = form.querySelector(`.${this.formPhoneInput}`);
    const phone = formPhone.value;

    const formQuestion = form.querySelector(`.${this.formQuestionInput}`);
    const question = formQuestion.value;

    $.request('Feedback::onAjax', {
      data: {
        name,
        email,
        phone,
        question,
      },
      loading: `.${this.preLoaderSelector}`,
      complete: (res) => {
        this.showTooltip(res);
      },
    });
  }
}();
